export default {
	namespaced: true,
	state: {
		aes: {
			passphrease: "Wakanda Forever"
		}
	},
	getters: {
		aesSecret(state) {
			return state.aes.passphrease
		}
	}
}